import { request } from './cloudApi';

export const advertisementApi = {
  // Public: Aktif reklamları getir
  async getActiveAdvertisements({ position, membershipType }) {
    try {
      const queryParams = new URLSearchParams();
      if (position) queryParams.set('position', position);
      if (membershipType) queryParams.set('membershipType', membershipType);

      const result = await request(`/advertisements/active${queryParams.toString() ? `?${queryParams.toString()}` : ''}`, {
        method: 'GET',
      });

      return result;
    } catch (error) {
      // Offline-first: Server bağlantı hatalarını sessizce handle et
      if (error.code === 'LOCAL_SERVER_NOT_RUNNING' || error.code === 'NETWORK_UNREACHABLE') {
        // Sessizce boş sonuç döndür
        return { success: false, advertisements: [] };
      }
      // Diğer hatalar için de sessizce boş sonuç döndür
      return { success: false, advertisements: [] };
    }
  },

  // Public: Reklam gösterimini kaydet
  async recordImpression({ adId, token }) {
    try {
      return await request(`/advertisements/${adId}/impression`, {
        method: 'POST',
        token,
      });
    } catch (error) {
      console.error('Record impression error:', error);
      throw error;
    }
  },

  // Public: Reklam tıklamasını kaydet
  async recordClick({ adId, token }) {
    try {
      return await request(`/advertisements/${adId}/click`, {
        method: 'POST',
        token,
      });
    } catch (error) {
      console.error('Record click error:', error);
      throw error;
    }
  },

  // Admin: Tüm reklamları getir
  async getAdvertisements({ token, filters = {} }) {
    try {
      const queryParams = new URLSearchParams();
      if (filters.position) queryParams.set('position', filters.position);
      if (filters.isActive !== undefined) queryParams.set('isActive', filters.isActive);
      if (filters.targetAudience) queryParams.set('targetAudience', filters.targetAudience);

      return await request(`/advertisements${queryParams.toString() ? `?${queryParams.toString()}` : ''}`, {
        method: 'GET',
        token,
      });
    } catch (error) {
      console.error('Get advertisements error:', error);
      throw error;
    }
  },

  // Admin: Reklam detayını getir
  async getAdvertisement({ token, adId }) {
    try {
      return await request(`/advertisements/${adId}`, {
        method: 'GET',
        token,
      });
    } catch (error) {
      console.error('Get advertisement error:', error);
      throw error;
    }
  },

  // Admin: Reklam oluştur
  async createAdvertisement({ token, adData }) {
    try {
      return await request('/advertisements', {
        method: 'POST',
        token,
        body: adData,
      });
    } catch (error) {
      console.error('Create advertisement error:', error);
      throw error;
    }
  },

  // Admin: Reklam güncelle
  async updateAdvertisement({ token, adId, adData }) {
    try {
      return await request(`/advertisements/${adId}`, {
        method: 'PUT',
        token,
        body: adData,
      });
    } catch (error) {
      console.error('Update advertisement error:', error);
      throw error;
    }
  },

  // Admin: Reklam sil
  async deleteAdvertisement({ token, adId }) {
    try {
      return await request(`/advertisements/${adId}`, {
        method: 'DELETE',
        token,
      });
    } catch (error) {
      console.error('Delete advertisement error:', error);
      throw error;
    }
  },

  // Admin: Reklam istatistiklerini getir
  async getAdvertisementStats({ token, adId }) {
    try {
      return await request(`/advertisements/${adId}/stats`, {
        method: 'GET',
        token,
      });
    } catch (error) {
      console.error('Get advertisement stats error:', error);
      throw error;
    }
  },
};

export default advertisementApi;






